import * as Sentry from '@sentry/browser';

const init = () => {
    if(!PROJECT_ENV.authDevelopment) {
        Sentry.init({ dsn: "https://79938175c19740ca992fd6a959a7884e@o401832.ingest.sentry.io/5262026" });
    }
}

const captureException = (err) => {
    if(!PROJECT_ENV.authDevelopment) {
        if (!(err instanceof Error)) {
            Sentry.captureMessage(JSON.stringify(err));
            return true;
        }

        setTimeout(() => Sentry.captureException(err), 0);
    }

}

const debug = function() {
    const params = window.location.search;

    if(params.toLowerCase().indexOf('jumbodebug=true') !== -1){
        for(let i = 0; i < arguments.length; i++){
            /* eslint-disable no-console */
            console.log(arguments[i]);
        }
    }
}

const Log = {
    init,
    captureException,
    debug
}

export default Log;
